import { ISettingsStore } from './settings-store';
import { from, Observable } from 'rxjs';
import { concatMap, first, map, reduce } from 'rxjs/operators';

export class CompositeSettingsStore implements ISettingsStore {
  private readonly _settingsStores: ISettingsStore[];
  constructor(providers: ISettingsStore[]) {
    this._settingsStores = providers;
  }
  getSetting$(key: string): Observable<string | null> {
    const storesWhatHaveNoValue: ISettingsStore[] = [];
    const stores = this._settingsStores;
    function cache(v: string | null, index: number): string | null {
      if (v === null) {
        storesWhatHaveNoValue.push(stores[index]);
      } else {
        storesWhatHaveNoValue.forEach((s) => s.setSetting$(key, v));
      }
      return v;
    }
    return from(this._settingsStores).pipe(
      concatMap((s) => s.getSetting$(key)),
      map((v, i) => cache(v, i)),
      first((v) => v !== null, null),
    );
  }
  setSetting$(settingKey: string, value: string): Observable<boolean> {
    return from(this._settingsStores).pipe(
      concatMap((s) => s.setSetting$(settingKey, value)),
      reduce((acc, val) => acc && val),
    );
  }
}
